import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import { GenerateOrder } from "../../../context/OrderContext";
import EmailNotification from "./EmailNotification";
import Extrainfo from "./Extrainfo";
import OrderForm from "./OrderForm";
import Print from "./PrintQuoteData";
import QuoteNotification from './QuoteNotification';

const OrderentryForm = React.memo(() => {
  return (
    <GenerateOrder>
      <div className="orderentryform">
        <Container fluid>
          <Row>
            <QuoteNotification />
            <EmailNotification />
            <Print />
            <Col sm={12} md={12} lg={9}>
              <OrderForm />
            </Col>
            <Col sm={12} md={12} lg={3}><Extrainfo /></Col>
          </Row>
        </Container>
      </div>
    </GenerateOrder>
  );
})
export default OrderentryForm;